export function createPortalContainer(id = 'sca-portal-container'): HTMLDivElement {
  const portalContainer = document.createElement('div');
  portalContainer.id = id;

  document.body.appendChild(portalContainer);
  return portalContainer;
}
